import React from 'react';

import { ProfileOutlined } from '@ant-design/icons';

const NotificationCardModuleAssignedIcon = () => {
  return <ProfileOutlined className="text-xl text-blue-500" />;
};

export default NotificationCardModuleAssignedIcon;
